import { Box, Flex, Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { ReactNode } from "react";

interface NotificationLayoutProps {
  children: ReactNode;
  title: ReactNode;
  goBack: () => void;
}

const NotificationLayout: React.FC<NotificationLayoutProps> = ({
  children,
  title,
  goBack,
}) => {
  return (
    <Flex direction={"column"} className="min-h-screen">
      <Flex gap={"md"} justify={"space-between"}>
        <Flex
          mih={66}
          px={14}
          className="border-b border-gray w-full"
          align={"center"}
          justify={"space-between"}
        >
          <Flex gap={"lg"} align={"center"}>
            <Box component="a" onClick={goBack} className="group/button">
              <IconChevronLeft className="text-gray group-hover/button:text-blue" />
            </Box>
            {typeof title === "string" ? (
              <Text size={"sm"} fw={600}>
                {title.toUpperCase()}
              </Text>
            ) : (
              title
            )}
          </Flex>
        </Flex>
      </Flex>
      <Box className="flex flex-col flex-1">{children}</Box>
    </Flex>
  );
};

export default NotificationLayout;
